<template>
  <div class="c--shared_h3-title">
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss" scoped>
  h3 {
    color: #4a4a4a;
    font-size: 1.3125rem;
    font-weight: 600;
    letter-spacing: -0.3px;
    line-height: 1.1904;
    margin-bottom: 10px;
  }
</style>
